import React, { FunctionComponent } from 'react'
import GatsbyImage from 'gatsby-image'
import { DocumentOutlineSection, H } from 'react-document-section'

import { Container, Row, Col, RowProps } from 'components/grid'
import {
  UnderlineCalloutHeader,
  UnderlineColors,
} from 'components/UnderlineText'
import { PrimaryButtonLink } from 'components/Buttons'
import RichTextField from 'components/rich-text-field'

import {
  contentWrapper,
  title as titleStyle,
  plainText,
  colImg,
  imageWrapper,
  cta,
} from './index.module.scss'

export interface TextWithImageProps {
  image: EF.FluidImageNode
  title: string
  underlineColor?: UnderlineColors
  text: string | EF.RTFRawQueryResponse
  imageToTheLeft?: boolean
  imageToTheTop?: boolean
  ctaText?: string
  ctaPath?: string
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}

const TextWithImage: FunctionComponent<TextWithImageProps> = ({
  image,
  title,
  underlineColor = UnderlineColors.Warm,
  text,
  imageToTheLeft,
  imageToTheTop,
  ctaText = '',
  ctaPath,
  onClick,
}) => {
  const rowProps: RowProps = imageToTheLeft ? {} : { reverse: 'lg' }

  return (
    <DocumentOutlineSection
      title={<UnderlineCalloutHeader text={title} color={underlineColor} />}
    >
      <Container>
        <Row {...rowProps}>
          <Col
            xs={12}
            lg={6}
            className={colImg}
            data-image-to-top={imageToTheTop}
          >
            <div
              className={imageWrapper}
              data-image-side={imageToTheLeft ? 'right' : 'left'}
            >
              <GatsbyImage
                fluid={image.fields.asset.fluid}
                alt={
                  image.description ||
                  image.fields.asset.description ||
                  image.title ||
                  image.fields.asset.title ||
                  ''
                }
              />
            </div>
          </Col>
          <Col xs={12} lg={6}>
            <div className={contentWrapper}>
              <div>
                <H className={titleStyle} />
                {typeof text === 'string' ? (
                  <p className={plainText}>{text}</p>
                ) : (
                  <RichTextField data={text} />
                )}
                {ctaText && ctaPath && (
                  <PrimaryButtonLink
                    text={ctaText}
                    path={ctaPath}
                    className={cta}
                    onClick={onClick}
                  />
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </DocumentOutlineSection>
  )
}

export default TextWithImage
